var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "RemoveView",
      class: _vm.modes.map((m) => `RemoveView--${m}`),
      attrs: { to: _vm.to },
    },
    [
      !!_vm.to
        ? _c(
            "router-link",
            {
              staticClass: "RemoveViewButton",
              attrs: { to: _vm.to },
              on: {
                click: function ($event) {
                  return _vm.$emit("click", $event)
                },
              },
            },
            [_c("svg-view", { attrs: { name: "close" } })],
            1
          )
        : _c(
            "div",
            {
              staticClass: "RemoveViewButton",
              on: {
                click: function ($event) {
                  return _vm.$emit("click", $event)
                },
              },
            },
            [_c("svg-view", { attrs: { name: "close" } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }